import {get} from "@/utils/request";


export default {
    getVisitsData: () => {
        return get('/index/visitsUsers');
    },
    getServerIP: () => {
        return get('/index/ip');
    },
    getOnlineData: () => {
        return get('/index/onlineUsers');
    },
    getNewsData: () => {
        return get('/index/newInfo');
    },
    getQuestionsData: (data) => {
        return get('/index/list', {type: data});
    },



}